import React from 'react'
import { Separator as ZionSeparator } from '@fs/zion-ui'

type SeparatorProps = {
  isGrowVertically?: boolean
  size?: 'none' | 'nano' | 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl'
}

export default function Separator({ isGrowVertically, size }: SeparatorProps): JSX.Element {
  if (size === 'none') {
    return <></>
  }
  const props = isGrowVertically ? { style: { marginTop: 'auto', flex: 1 } } : {}
  return (
    <div data-testid="zion-cms-separator" {...props}>
      <ZionSeparator size={size} />
    </div>
  )
}
